(function(w) {
    'use strict';

    const done = () => {
      if (!S$Q('.pfp')?.classList.contains('pfp_loading')) return;
      S$Q('.pfp')?.classList.remove('pfp_loading');
      if (S$$('.framefh').length){
        S$Q('.dp_st__atc-btn')?.classList.remove('disa');
      } else {
        Pg.Frames?.updateFrameSizes("PageLoad");
      }
      Pg.Cart?.buildFramesSummary?.();
    };
  
    Pg.Main = {
      logInfo: () => cLog('📦 Pg.Main module loaded'),

      // Global UI dimensions - accessible via Pg.Main.ui
      ui: {
        headHeight: 0,
        galHeight: 0,
        epuHeight: 0,
        epuBodyHeight: 0,
        epuFooterHeight: 0
      },

      // Method to calculate and update UI dimensions
      calculateUIDimensions() {
        if (dType === "M") {
          const elHeight = selector => S$Q(selector)?.offsetHeight || 0;
          this.ui.headHeight = ['.pfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
          this.ui.galHeight = window.innerHeight - ['.pfp-h_banner', 'header.header', '.dp_sidebar', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
          this.ui.epuHeight = window.innerHeight - ['.pfp-h_banner', 'header.header', '.announcement-bar'].reduce((sum, sel) => sum + elHeight(sel), 0);
          this.ui.epuBodyHeight = this.ui.epuHeight - 160;
          this.ui.epuFooterHeight = this.ui.epuHeight - this.ui.epuBodyHeight;
        }
        return this.ui;
      },

      setupMobileUI() {
        if (dType === "M") {
          // Calculate dimensions and store globally
          this.calculateUIDimensions();
          
          // Use the globally stored values
          const { headHeight, galHeight, epuHeight, epuBodyHeight, epuFooterHeight } = this.ui;
          S$Q(".dp_wrapper").style.height = galHeight + "px";
          const navHeight = window.screen.height - window.innerHeight;
          S$Q(".dp_sbmd").style.paddingBottom = navHeight + "px";
          /*
          S$Q(".dp_epu-box").style.top = headHeight + "px";
          S$Q(".dp_epu-box").style.height = epuHeight + "px";
          S$Q(".dp_epu-body").style.maxHeight = epuBodyHeight + "px";
          S$Q(".dp_epu-body").style.height = epuBodyHeight + "px";
          S$Q(".dp_epu-footer").style.height = epuFooterHeight + "px";
          */
          document.documentElement.style.setProperty(`--total-header-height`, `${headHeight}px`);
        }
      },

      setupUIEventListeners() {
        // Acrylic checkbox listeners with immediate ATC disable
        Pg.Utils.el.acrylicCB?.addEventListener('change', (e) => {
          // Disable ATC button immediately on acrylic change
          S$Q('.dp_st__atc-btn')?.classList.add('disa');
          window.Pg?.Frames?.handleCheckboxChange(e);
          setTimeout(() => {
            // if (S$$(".framefh")?.length !== 0) 
              S$Q('.dp_st__atc-btn')?.classList.remove('disa');
          }, 1000);
        });
        Pg.Utils.el.PUacrylicCB?.addEventListener('change', (e) => {
          // Disable ATC button immediately on popup acrylic change
          S$Q('.dp_st__atc-btn')?.classList.add('disa');
          window.Pg?.Frames?.handleCheckboxChange(e);
          setTimeout(() => {
            // if (S$$(".framefh")?.length !== 0) 
              S$Q('.dp_st__atc-btn')?.classList.remove('disa');
          }, 1000);
        });

        // bw listeners
        // document.querySelector('.dp_vp__bw-box input').addEventListener('change', (e) => {
        //     S$Q('.dp_st__atc-btn')?.classList.add('disa');
        //     window.Pg?.Frames?.handleBwCheckboxChange(e);
        // });

        // Accordion listeners
        document.querySelectorAll('.accordionb_bttn').forEach(el => {
          el.addEventListener('click', () => {
            document.getElementById('MainContent').classList.toggle('dp_fs-collapse__open');
          });
        });

        // Details button listeners
        document.querySelectorAll('.dp_st__details-btn').forEach(el => {
          el.addEventListener('click', () => {
            S$G('global-overlay').classList.add('go-active');
            S$Q('.dp_sbmd').classList.add('dp_sbmd-open');
          });
        });

        // Sidebar close listeners
        document.querySelectorAll('.dp_sbmd__title-box').forEach(el => {
          el.addEventListener('click', () => {
            S$G('global-overlay').classList.remove('go-active');
            S$Q('.dp_sbmd').classList.remove('dp_sbmd-open');
          });
        });

        // Delivery info listeners
        document.querySelectorAll('.dp_sbmd__view_del').forEach(el => {
          el.addEventListener('click', () => {
            S$Q('.dp_delivery_info').classList.add('dp_delivery_info-open');
            if (dType === "D") S$G("background-overlay").style.display = "block";
          });
        });

        document.querySelectorAll('.dp_delinfo-close').forEach(el => {
          el.addEventListener('click', () => {
            S$Q('.dp_delivery_info').classList.remove('dp_delivery_info-open');
            dType === "D" ? S$G("background-overlay").style.display = "none" : S$Q('.dp_sbmd').classList.remove('dp_sbmd-open'), S$G('global-overlay').classList.remove('go-active');
          });
        });

        document.querySelectorAll('.dp_delinfo-back').forEach(el => {
          el.addEventListener('click', () => {
            S$Q('.dp_delivery_info').classList.remove('dp_delivery_info-open');
          });
        });

        // Upload popup listeners
        S$Q('.dp_upu')?.addEventListener('click', function (event) {
          event.currentTarget.classList.remove("dp_upu-open");
        });

        S$Q(".dp_fub__container")?.addEventListener('click', function () {
          document.querySelector('.dp_upu')?.classList.add("dp_upu-open");
        });

        S$Q('.btns-group')?.addEventListener('click', function () {
          document.querySelector('.dp_upu')?.classList.add("dp_upu-open");
        });
      },

      setupMobileMenu() {
        if(dType === "M"){
          // Mobile menu option handlers
          S$$('.dp_mem-fm_option').forEach(b => b.addEventListener('click', this.mobileMainMenuHandler));
          
          // Mobile menu done handlers
          S$$('.dp_mem-done').forEach(b => b.addEventListener('click', this.mobileMainDoneHandler));
        }
      },

      mobileMainMenuHandler(e) {
        const oe = e.currentTarget.querySelector('.dp_mem-fmo_text').innerText.toLowerCase();
        Pg.Utils.el.pfp.className = "pfp dp_mem-open_" + oe;
      },

      mobileMainDoneHandler(e) {
        Pg.Utils.el.pfp.className = "pfp";
      },

      setupTouchHandling() {
        let lastTouchEnd = 0;

        document.addEventListener('touchend', (event) => {
          const now = Date.now();
          if (now - lastTouchEnd <= 300 && event.cancelable) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        }, { passive: false });

        document.addEventListener('gesturestart', (e) => e.preventDefault());
      },

      setupSwiper() {
        const rSwiper = new Swiper(".rSwiper", {
          slidesPerView: 1,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        });
      },

      setupImageHandling() {
        // Image upload listener
        S$G('upload-img')?.addEventListener('change', window.Pg?.Images?.previewImgs, true);
      },

      setupEventListeners() {
        document.addEventListener('click', (e) => {
          var actionElement = e.target.hasAttribute('data-action') ? e.target : e.target.closest('[data-action]');
          if (!actionElement) return;
          var action = actionElement.getAttribute('data-action');

          if(action === 'sidebar-selection'){
            const target = e.target.closest('[data-value]');
            const container = e.target.closest('[data-category]');
            if (!target || !container) return;

            const category = container.getAttribute('data-category');
            const value = target.getAttribute('data-value');
            
            // Disable ATC button immediately on size/style/border/acrylic clicks
            if(['size', 'style', 'border'].includes(category)) {
              S$Q('.dp_st__atc-btn')?.classList.add('disa');
              setTimeout(() => {
                // if (S$$(".framefh")?.length !== 0) 
                  S$Q('.dp_st__atc-btn')?.classList.remove('disa');
              }, 1000);
            }
            
            if(this.checkFC(category)){
              const hasFrameFH = S$$('.framefh')?.length !== 0;
              const frame       = S$Q('.frame:not(.framefh)');
              const framefh     = S$Q('.framefh');

              const frameVal    = frame?.getAttribute('data-frame-' + category);
              const framefhVal  = framefh?.getAttribute('data-frame-' + category);

              const frameSize   = frame ? frame.getAttribute('data-width-in-inches') + 'x' +  frame.getAttribute('data-height-in-inches') : null;
              const framefhSize = framefh ? framefh.getAttribute('data-width-in-inches') + 'x' + framefh.getAttribute('data-height-in-inches') : null;
              
              if(hasFrameFH && category.toLowerCase() === 'size' && value === frameSize && value === framefhSize){
                console.warn("skipping because value and selected size is same for all")
                return;
              }else if(hasFrameFH && value === frameVal && value === framefhVal){
                console.warn(`skipping because value (${value}) and selected ${category} is same (${frameVal}) for all`)
                return;
              }
              this.updateSelectedValue(container, target, category, value);
            }else{
              this.changeAllWarningShow(container, target, category, value);
            }
          }else if(action === 'popup-menu'){
            const target = e.target.closest('[data-value]');
            const value = target.getAttribute('data-value');
            if (value == "delete") {
              var epopup = S$Q('.dp_epu');
              var eframe = S$Q('.dp_epu-body .frame');
              var ftu = S$Q('.img-thumbs .frame[data-frame-index="' + epopup.dataset.editIndex + '"]').parentElement;
              var frameId = ftu.querySelector('.framefh')?.dataset.frameId;
              ftu.remove();
              epopup.style.display = "none";
              eframe.remove();
              Pg.State?.removeFrame(frameId);
              Pg.Frames.setFID();
              var frames = S$$('.frame');
              Pg.Frames.updateFrameSizes("size");
              Pg.Frames.handleSwiper(frames);
              Pg.Cart?.buildFramesSummary?.();
              Pg.Popup.current.isOpen = false;
              if(S$$('.framefh').length == 0){
                // S$Q('.dp_st__atc-btn').classList.add('disa');
              }
            } else {
              var p = "dp_epu-f" + value;
              actionElement.parentElement.parentElement.parentElement.querySelector('.dp_epu-fcurrent').classList.remove('dp_epu-fcurrent');
              S$Q('.dp_epu-footer').dataset.active = p;
              actionElement.parentElement.parentElement.parentElement.querySelector('.' + p).classList.add('dp_epu-fcurrent');
              if(S$Q('.dp_epu-sbm_option.sideB')) S$Q('.dp_epu-sbm_option.sideB').style.display = "none";
              if (p === "dp_epu-facrylic") {
                const frame = actionElement.parentElement.parentElement.parentElement.querySelector('.' + p)?.closest('.dp_epu-box')?.querySelector('.frame.framefh');
                S$G('epuacr').checked = frame?.getAttribute('data-frame-acrylic') === "true";
              }
            };
          }else if(action === 'popup-selection'){
            const target = e.target.closest('[data-value]');
            const container = e.target.closest('[data-category]');
            if (!target || !container) return;

            const category = container.getAttribute('data-category');
            const value = target.getAttribute('data-value');
            this.updateSelectedValuePopup(container, target, category, value);
          }else if(action === 'popup-selection-done'){
            S$Q('.dp_epu-fcurrent').classList.remove('dp_epu-fcurrent');
            S$Q('.dp_epu-fmain').classList.add('dp_epu-fcurrent');
            S$Q('.dp_epu-footer').dataset.active = "dp_epu-fmain";
            if(S$Q('.dp_epu-sbm_option.sideB')) S$Q('.dp_epu-sbm_option.sideB').style.display = "flex";
            Pg.Images.loadImageForEditing();
          }else if(action === 'popup-done'){
            Pg.Frames.endSEdit();
          }else if(action === 'popup-cancel'){
            if(!Pg.Popup.current.isOpen) return;
            S$Q('.dp_epu-fcurrent').classList.remove('dp_epu-fcurrent');
            S$Q('.dp_epu-fmain').classList.add('dp_epu-fcurrent');
            S$Q('.dp_epu-footer').dataset.active = "dp_epu-fmain";
            // S$Q('.dp_epu').style.display = "none";
            // S$Q('.dp_epu-body .frame').remove();
            Pg.Popup.current.isOpen = false;
            const pu = Pg.Popup.current;
            const frameId = pu?.cuF?.dataset?.frameId;

            if (frameId && pu?.cuF) {
              pu.cuF.offsetHeight;
              Pg.Frames.updateFrameCssStyles(frameId, {
                padding: (parseFloat(pu.cuF.style.padding)) + "px",
                borderWidth: (parseFloat(pu.cuF.style.borderWidth)) + "px",
                height: (parseFloat(pu.cuF.style.height)) + "px",
                width: (parseFloat(pu.cuF.style.width)) + "px",
              });
            }
            Pg.Frames.closePopupAnimation(true);
          }else if(action === 'popup-direct-action'){
            const target = e.target.closest('[data-value]');
            if (!target) return;

            const value = target.getAttribute('data-value');
            if(value === "black-white"){
              const img = w.Pg.Popup.current.ceI;
              if (!img) return;
  
              const isGrayscale = img.style.filter?.includes('grayscale');
              // img.style.filter = isGrayscale ? 'none' : 'grayscale(100%)';
              if (isGrayscale) {
                  img.style.filter = 'none';
                  img.style.webkitFilter = 'none';
              } else {
                  img.style.filter = 'grayscale(100%)';
                  img.style.webkitFilter = 'grayscale(100%)';
              }
              w.Pg.Popup.update({
                cuBW: !isGrayscale,
                soBWchanged: true,
              });
            }
          }
        });

        function confirmReloadIfUploading() {
          console.log(w?.Pg?.State?.data?.computed?.uploadProgress?.hasUploading || (w?.Pg.State.data.uploadQueue.length > 0))
          const hasUploads = w?.Pg?.State?.data?.computed?.uploadProgress?.hasUploading || (w?.Pg.State.data.uploadQueue.length > 0);
          return !hasUploads || confirm("Uploads in progress. Leave anyway?");
        }

        window.addEventListener("keydown", (e) => {
          if (e.key === "F5" || ((e.ctrlKey || e.metaKey) && e.key === "r")) {
            if (!confirmReloadIfUploading()) {
              e.preventDefault();
            }
          }
        });

        window.addEventListener("beforeunload", (e) => {
          console.log(w?.Pg?.State?.data?.computed?.uploadProgress?.hasUploading || (w?.Pg.State.data.uploadQueue.length > 0))
          if (w?.Pg?.State?.data?.computed?.uploadProgress?.hasUploading || (w?.Pg.State.data.uploadQueue.length > 0)) {
            e.preventDefault();
            e.returnValue = "Uploads in progress. Leave anyway?";
            return "Uploads in progress. Leave anyway?";
          }
        });
      },

      checkFC(cat) {
        const frames = S$$('.framefh');
        if (!frames.length) return true;
        if(cat === 'size'){
          const width = frames[0].getAttribute('data-width-in-inches');
          const height = frames[0].getAttribute('data-height-in-inches');
          const allSame = [...frames].every(frame => frame.getAttribute('data-width-in-inches') === width && frame.getAttribute('data-height-in-inches') === height);
          return allSame;
        }
        const first = frames[0].getAttribute('data-frame-' + cat);
        const allSame = [...frames].every(frame => frame.getAttribute('data-frame-' + cat) === first);
        return allSame;
      },

      updateSelectedValue(container, target, category, value) {
        container.querySelector('.selected')?.classList.remove('selected');
        target.classList.add('selected');
        container.setAttribute('data-selected-value', value);
        switch(category){
          case 'size':
            const [width, height] = value.split('x');
            Pg.Frames.updateAllFramesInches(parseInt(width), parseInt(height));
            break;
          case 'style':
            Pg.Frames.updateAllFramesStyles(value);
            break;
          case 'border':
              Pg.Frames.updateAllFramesBorder(value);
            break;
          default:
            break;
        }
      },

      updateSelectedValuePopup(container, target, category, value) {
        container.querySelector('.selected')?.classList.remove('selected');
        target.classList.add('selected');
        container.setAttribute('data-selected-value', value);
        switch(category){
          case 'size':
            const [width, height] = value.split('x');
            Pg.Frames.updateSingleFrameSize(parseInt(width), parseInt(height));
            break;
          case 'style':
            S$Q('.dp_epu-body .frame').setAttribute('data-frame-style', value);
            break;
          case 'border':
              Pg.Frames.updateSingleFrameBorder(value);
            break;
          default:
            break;
        }
      },

      changeAllWarningShow(container, target, category, value) {
        S$G('fpcp').style.display = "block";
        S$G('background-overlay').style.display = "block";
        S$Q('.fpcpApply').addEventListener('click', function () {
          Pg.Main.updateSelectedValue(container, target, category, value);
          S$G('fpcp').style.display = "none";
          S$G('background-overlay').style.display = "none";
        }, { once: true });
        S$Q('.fpcpDiscard').addEventListener('click', function () {
          S$G('fpcp').style.display = "none";
          S$G('background-overlay').style.display = "none";
        }, { once: true });
      },
  
      init() {
        this.setupEventListeners();
        this.setupMobileUI();
        this.setupUIEventListeners();
        this.setupMobileMenu();
        this.setupTouchHandling();
        this.setupSwiper();
        this.setupImageHandling();
        
        // Initialize safe area insets
        window.Pg?.Utils?.updateSafeAreaInsets();

        // Add resize listener to recalculate UI dimensions
        if (dType === "M") {
          window.addEventListener('resize', () => {
            this.calculateUIDimensions();
          });
        }
        var isDone = 0;
        setTimeout(() => {
          if(isDone == 1) return;
          console.log('✅ done called from fallback timeout (2s)');
          isDone = 1;
          done();
        }, 3000);                         
        w.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => {
            if(isDone == 1) return;
            console.log('✅ done called from DOMContentLoaded timeout (0.5s)');
            isDone = 1;
            done();
          }, 500);  
          const el = S$Q('.dp_delinfo_date');
          if (el) {
            const d = new Date(); d.setDate(d.getDate() + 7);
            el.textContent = d.toLocaleDateString('en-US', {
              weekday: 'long', month: 'short', day: '2-digit',
            });
          }

          // Initialize upload system
          setTimeout(() => {
            this.initializeUploadSystem();
          }, 2000);
        });
      },

      initializeUploadSystem() {
        cLog('🚀 Initializing upload system');
        
        // Update add to cart button state
        if (Pg.Cart && typeof Pg.Cart.updateAddToCartButton === 'function') {
          Pg.Cart.updateAddToCartButton();
        }

        // Resume any interrupted uploads
        if (Pg.Images && typeof Pg.Images.resumeUploads === 'function') {
          Pg.Images.resumeUploads();
        }

        cLog('✅ Upload system initialized');
      },
    };
  
    /* signal module loaded / run */
    Pg.moduleStatus && (Pg.moduleStatus.Main = true, Pg.checkModules?.());
    !Pg._silentLoad  && Pg.Main.logInfo();
    !Pg._silentInit  && setTimeout(() => Pg.Main.init(), 100);
  
  })(window); 
